import * as Blockly from 'blockly/core';
import 'blockly/python';
//import {getAllowedOutputs} from "./strata_compatibility_checks";
import createCustomThresholdFields from "../strata/strata_custom_threshold_fields";

Blockly.Blocks['globe_mask'] = {
    init: function() {
      this.appendDummyInput()
          .setAlign(Blockly.ALIGN_LEFT)
          .appendField("Mask   ")
          .appendField(new Blockly.FieldDropdown([
            ["Forest Cover", "forest_cov"],
            ["Forest Cover 10m", "forest_cov_10m"],
            ["Wind Speed", "wnd_msk"],
            ["Fires", "fr_msk"],
            ["Permanent Water", "water_msk"],
            ["Slope Mask", "slope_msk"]
          ]), "indicator_selection");
      
      createCustomThresholdFields(this);
        
      this.appendDummyInput()
          .setAlign(Blockly.ALIGN_RIGHT)
          .appendField(new Blockly.FieldLabelSerializable("weight"), "weight")
          .appendField(new Blockly.FieldNumber(1), "weightval")
          .setVisible(false); 
      this.setPreviousStatement(true, 'masks');
      this.setNextStatement(true);
      this.setStyle('changeDetection');
     
      this.setTooltip("");
      this.setHelpUrl("");
    }
  }